import moment from 'moment';

const COMMISSIONING_SERVICE_RELEASE_DATE = '2021-10-20T00:00:00.000Z';
const GET_LAST_COMMISSION_DATE_STATUS = {
  PENDING: 0,
  NOT_FOUND: -1
};

// The status of an orchestration instance.
const orchestrationRuntimeStatus = {
  /**
   * The orchestration instance has started running.
   */
  Running: 'Running',
  /**
   * The orchestration instance has completed normally.
   */
  Completed: 'Completed',
  /**
   * The orchestration instance has restarted itself with a new history.
   * This is a transient state.
   */
  ContinuedAsNew: 'ContinuedAsNew',
  /**
   * The orchestration instance failed with an error.
   */
  Failed: 'Failed',
  /**
   * The orchestration was canceled gracefully.
   */
  Canceled: 'Canceled',
  /**
   * The orchestration instance was stopped abruptly.
   */
  Terminated: 'Terminated',
  /**
   * The orchestration instance has been scheduled but has not yet started
   * running.
   */
  Pending: 'Pending'
};

const getLastSuccessfulCommissionDate = (searchRes) => {
  const instances = searchRes?.instances;
  if (!instances || instances.length === 0) return GET_LAST_COMMISSION_DATE_STATUS.NOT_FOUND;
  let res;

  instances.forEach((instance) => {
    const createdTime = instance.createdTime;
    const runtimeStatus = instance.runtimeStatus;
    const customStatus = instance?.customStatus?.status;

    if (runtimeStatus === orchestrationRuntimeStatus.Completed && customStatus === 'completed') {
      if (!res) {
        res = createdTime;
        return;
      }

      if (moment(createdTime).isAfter(moment(res))) {
        res = createdTime;
      }
    }
  });

  return res ?? GET_LAST_COMMISSION_DATE_STATUS.NOT_FOUND;
};

export { GET_LAST_COMMISSION_DATE_STATUS, COMMISSIONING_SERVICE_RELEASE_DATE, getLastSuccessfulCommissionDate };
